import React from 'react';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  callApiSystemSetting,
  updateNotificationSubscribed,
} from '../../reducer';
import { setLocale, Translate } from 'react-redux-i18n';
import {
  changeTheme,
  changeLanguage,
  changeFontSize,
} from './../../../../app/reducer';
import { isNotLogin } from '../../../../helpers/Common';

const TIME_SHOW = 5000;

class SaveButton extends React.Component {
  state = {
    isShowSuccessMessage: false,
  };

  componentWillReceiveProps(nextProps, nextContext) {
    const { isLoading } = this.props;
    if (isLoading && !nextProps.isLoading) {
      this.setSuccessMessage();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  setSuccessMessage = () => {
    clearTimeout(this.timeout);
    this.setState({
      isShowSuccessMessage: true,
    });

    this.timeout = setTimeout(() => {
      this.setState({
        isShowSuccessMessage: false,
      });
    }, TIME_SHOW);
  };

  actionSave = () => {
    const {
      dataSystem,
      callApiSystemSetting,
      data,
      changeTheme,
      changeLanguage,
      changeFontSize,
      user,
      updateNotificationSubscribed,
    } = this.props;

    if (data && data.theme) {
      changeTheme(data.theme);
    }
    if (data && data.language) {
      changeLanguage(data.language);
    }
    if (data && data.fontSize) {
      changeFontSize(data.fontSize);
    }

    if (data.notificationSubscribed !== undefined) {
      updateNotificationSubscribed(data.notificationSubscribed);
    }

    if (isNotLogin(user)) {
      this.setSuccessMessage();
    } else {
      callApiSystemSetting({ ...dataSystem, ...data });
    }
  };

  getIsLoading = () => {
    const { isLoading, user } = this.props;
    if (isNotLogin(user)) {
      return false;
    }

    return isLoading;
  };

  render() {
    const { isShowSuccessMessage } = this.state;
    const { isLoading } = this.props;
    const addClass = isLoading ? 'process' : '';
    return (
      <div className="wrap-group-button">
        <div className={addClass}>
          <div
            className="save d-flex align-items-center"
            onClick={this.actionSave}
          >
            <span
              className="circle-loading"
              style={{ display: this.getIsLoading() ? 'block' : 'none' }}
            />
            <span className="title-button">
              <Translate value="systemSetting.saveButton" />
            </span>
          </div>
        </div>
        {isShowSuccessMessage && (
          <div className="save-message">
            <i className="icon-info" />
            <Translate value="layout.saveSettingMessage" />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dataSystem: state[REDUCER_NAME].settingSystem.dataSystem,
    isLoading: state[REDUCER_NAME].settingSystem.isLoading,
    user: state.userInfo,
  };
};

const mapDispatchToProp = {
  setLocale,
  callApiSystemSetting,
  changeTheme,
  changeLanguage,
  changeFontSize,
  updateNotificationSubscribed,
};

export default connect(
  mapStateToProps,
  mapDispatchToProp,
)(SaveButton);
